import { render, staticRenderFns } from "./onboarding.vue?vue&type=template&id=a89a5bd0"
import script from "./onboarding.vue?vue&type=script&lang=js"
export * from "./onboarding.vue?vue&type=script&lang=js"
import style0 from "./onboarding.vue?vue&type=style&index=0&id=a89a5bd0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports